import React, { useEffect, useState } from 'react';
import './index.css'

function Privacy() {
	return (
		<>
			<div className="css-ya0cdy">
				<div className="ztext">
					<h1>个人信息保护指引</h1>
					<p>
						第 1.0 版本 - 江子辰修订 <br />
						更新日期：2022 年 06 月 16 日 <br />
						生效日期：2022 年 06 月 20 日
					</p>
					<p>
						X站产品或服务是由<strong>前端江太公（网称）</strong>提供（以下简称「X站」或「我们」）。我们为用户（以下简称「您」）通过前端江太公站点（https://jiangsihan.cn）、X站网站（https://jiangsihan.cn）、小程序以及我们现在或将来还可能不时提供的其他程序、软件、客户端或其他类似产品（以下统称「本平台」）提供在线图片漫画交流网络社区的产品和服务（包括以问答产品或其他形式组织的内容产品和/或有关服务），以「让人们更好地分享知识、经验和见解,找到自己的解答」为使命，旨在以可持续发展、独立运营并获得健康增长的方式通过社区产品提供值得信赖的内容给用户。我们根据《中华人民共和国网络安全法》《中华人民共和国个人信息保护法》《中华人民共和国数据安全法》《常见类型移动互联网应用程序必要个人信息范围规定》等法律法规，并参考《信息安全技术
						个人信息安全规范》（GB/T
						35273-2020）等国家标准，制定X站《个人信息保护指引》（以下简称「本指引」）并致力于保护您的个人信息安全。
					</p>
					<p>
						<strong
						>请您在使用本平台前，仔细阅读并充分理解本指引。重点内容我们已采用粗体标示，希望您特别关注。</strong
						>
					</p>
					<p>
						如对本指引有任何疑问，您可以通过本指引中第九节「如何联系我们」提供的联系方式与我们联系。我们会不时对指引进行修订。当依照本指引第八节发生实质变更时，我们会在版本更新后以推送通知、弹窗、系统通知、站内私信等形式向您展示变更后的内容。
					</p>
					<p><strong>目录:</strong></p>
					<nav className="toc">
						<ol>
							<li>
								<a href="#我们如何收集和使用您的个人信息">我们如何收集和使用您的个人信息</a>
								<ol>
									<li>
										<a href="#我们将在以下业务场景收集和使用您的个人信息："
										>我们将在以下业务场景收集和使用您的个人信息：</a
										>
										<ol></ol>
									</li>
									<li>
										<a href="#X站-App-所调用的系统权限">X站 App 所调用的系统权限</a>
									</li>
									<li>
										<a href="#除同意外的其他合法性事由">除同意外的其他合法性事由</a>
									</li>
								</ol>
							</li>
							<li>
								<a href="#我们如何委托处理、共享、转让、公开披露您的个人信息"
								>我们如何委托处理、共享、转让、公开披露您的个人信息</a
								>
								<ol>
									<li><a href="#委托处理您的个人信息">委托处理您的个人信息</a></li>
									<li><a href="#共享您的个人信息">共享您的个人信息</a></li>
									<li><a href="#转让您的个人信息">转让您的个人信息</a></li>
									<li><a href="#公开披露您的个人信息">公开披露您的个人信息</a></li>
								</ol>
							</li>
							<li>
								<a href="#我们如何保护您的个人信息">我们如何保护您的个人信息</a>
								<ol>
									<li><a href="#技术措施与数据安全措施">技术措施与数据安全措施</a></li>
									<li><a href="#安全认证">安全认证</a></li>
									<li><a href="#安全事件处置">安全事件处置</a></li>
								</ol>
							</li>
							<li>
								<a href="#您如何管理您的个人信息">您如何管理您的个人信息</a>
								<ol>
									<li>
										<a href="#管理帐号、发布的内容与相关记录"
										>管理帐号、发布的内容与相关记录</a
										>
										<ol></ol>
									</li>
									<li><a href="#删除您的个人信息">删除您的个人信息</a></li>
									<li><a href="#获取您的个人信息">获取您的个人信息</a></li>
									<li><a href="#撤回您的授权同意">撤回您的授权同意</a></li>
									<li><a href="#注销X站帐号">注销X站帐号</a></li>
									<li><a href="#限制处理您的个人信息">限制处理您的个人信息</a></li>
									<li><a href="#响应您的上述请求">响应您的上述请求</a></li>
								</ol>
							</li>
							<li><a href="#我们如何存储您的个人信息">我们如何存储您的个人信息</a></li>
							<li>
								<a href="#我们如何使用-Cookie-和其他技术">我们如何使用 Cookie 和其他技术</a>
							</li>
							<li>
								<a href="#我们如何处理未成年人的个人信息">我们如何处理未成年人的个人信息</a>
							</li>
							<li><a href="#我们如何更新与修改本指引">我们如何更新与修改本指引</a></li>
							<li><a href="#您如何联系我们">您如何联系我们</a></li>
							<li><a href="#争议解决">争议解决</a></li>
							<li><a href="#概念及定义">概念及定义</a></li>
						</ol>
					</nav>
					<h2 id="">
						我们如何收集和使用您的个人信息<a
							className="smart-anchor"
							id="我们如何收集和使用您的个人信息"
						></a>
					</h2>
					<p>
						<strong
						>我们会遵循正当、合法、必要的原则，出于本指引所述的以下目的，收集和使用您在使用服务过程中主动提供或因使用X站产品和/或服务而产生的个人信息。如果我们要将您的个人信息用于本指引未载明的其它用途，或基于特定目的将收集而来的信息用于其他目的，我们将以合理的方式向您告知，并再次征得您的同意。如果您对下列内容中的概念有疑问，请查阅第十一条的定义和解释。</strong
						>
					</p>
					<p>
						<strong
						>在您使用X站产品和/或服务时，我们需要/可能需要在如下两种情况下收集和使用您的个人信息：</strong
						>
						<strong
						>为实现向您提供X站产品和/或服务基本的业务功能（属于全部业务功能的一部分），您须授权我们收集、使用的必要信息。如您拒绝提供相应信息，您将无法使用相应X站的产品和/或服务最基本的功能，即参与问答社区最基本的活动，包括提问和回答，得到适合您提问和/或回答的相关信息。</strong
						>
						<strong
						>在您使用X站产品和/或服务时，我们需要/可能需要在如下两种情况下收集和使用您的个人信息：</strong
						>
						<strong
						>在提供相对基本的业务功能以外，我们一直在努力提供更丰富的X站产品和/服务，以扩展、提高和加强您的使用体验；此类业务功能需要收集、使用相应的必要个人信息。如您拒绝提供，您将无法使用该等扩展体验的业务功能或无法达到我们拟达到的最佳扩展功能效果和体验，但并不会影响您正常使用X站产品和/或服务基本的业务功能。</strong
						>
					</p>
					<p>
						如您拒绝X站收集您的任何个人信息，X站将无法向您提供包括基本业务功能在内的本平台任何功能。在此情况下，X站向您提供
						<strong>「仅浏览」模式</strong
						>，旨在协助您在决定接受本指引前得到本平台的初步体验，即<strong
						>部分内容浏览，该等信息一般是基于其他用户同意本指引并提供他们的必要个人信息生成的内容。</strong
						>
					</p>
					<p>
						提示您注意：由于不同的产品或服务所需的个人信息有所不同，我们还会在您使用具体产品和/或服务前通过页面提示、交互流程等方式征求您的同意，获取个人信息的范围以您同意的特定产品和/或服务的协议或规则为准。
					</p>
					<p>
						由于我们向您提供的产品和/或服务是不断更新的，如果某一产品或服务未在前述内容中说明且收集了您的信息，我们会通过页面提示、交互流程、网站公告等方式另行向您说明信息收集的内容，以征得您的单独同意。该说明构成本指引的一部分，且该信息适用本指引的约定。
					</p>
					<h3 id="">
						我们将在以下业务场景收集和使用您的个人信息：<a
							className="smart-anchor"
							id="我们将在以下业务场景收集和使用您的个人信息："
						></a>
					</h3>
					<h4>帐号注册、登录、帐号绑定和安全</h4>
					<p>
						当您注册和登录X站帐号时，我们依据实名制相关法律规定，需要您提供<strong>有效的中国大陆手机号码</strong>。请您注意，您向我们提供中国大陆手机号码是我们向您提供基本业务功能所必需的个人信息，<strong
						>如您拒绝提供，则我们无法向您提供X站基本的业务功能，您将仅能使用「仅浏览」模式。</strong
						>
					</p>
					<p>
						<strong
						>您也可以使用邮箱、海外手机号的方式注册和登录X站，但我们会在您登录成功后的合法场景下，要求您进一步提供中国大陆手机号码以满足实名制的相关规定。</strong
						>
					</p>
					<p>
						<strong
						>当您使用第三方帐号（包括微信、QQ、微博、Apple
							ID）登录X站时，您需要授权X站在符合相关法律法规的前提下读取并共享获得您在该第三方平台上公布、记录的公开信息（包括昵称、头像、地区、性别、联系邮箱中的一项或几项），<strong>以便将您的第三方帐号与X站帐号进行绑定，并记住您作为X站用户的登录身份</strong>。</strong
						>
					</p>
					<p>
						当需要修改帐号密码时，请您输入新密码，以完成重置。当您需要修改手机号时，请您输入新手机号和短信验证码。您可以自愿在设置页面绑定您的邮箱，此时，您需要提供您的邮箱帐号和我们发送给您的短信验证码进行验证操作。如您需设置信任设备，您需要向我们提供您正在使用的设备名称、设备类型、最后使用时间。当您开通X站机构号时，您需要向我们提供您的邮箱地址、登录密码。
					</p>
					<p>
						当您的帐号无法使用时，您可以通过帐号申诉进行找回。此时，您可以选择提供您帐号绑定的<strong>手机号码</strong>、邮箱、用过的密码、注册时间、常用访问城市、手机端登录常用设备、PC
						端登录常用浏览器、X站消费记录、曾用名、曾用一句话介绍或个人简介的任一几项，以便我们核实您的身份。请您知悉，您可自行选择填写前述信息中的一项或几项，但您提供的信息需达到足够判断出您有权使用该帐号的合理程度。
					</p>
					<h4>话题讨论、信息分享和关注互动</h4>
					<p>
						当您注册成为X站用户并登录本平台后，您可以在本平台使用基本的业务功能，包括（1）阅读、浏览其他用户或X站发布的「问答、想法、视频、专栏、文章、课程、书籍、直播」等内容；（2）发布「问题、回答、文章、专栏、想法、视频」等内容；（3）与其他用户进行互动，包括编辑其他用户的提问，邀请其他用户回答问题，向其他用户发送私信，对其他用户发布的内容进行评价（包括赞同、反对、喜欢、收藏和评论）、订阅问题与关注其他用户。为保证提供服务的安全性、稳定性以及X站服务的可持续性和健康成长，我们会收集在此过程中产生的网络日志信息，留存您发布的内容（包括图片、文字、音视频信息）。
					</p>
					<p>
						当您通过X站小程序（包括微信平台小程序、百度平台小程序等）或其他除X站 App
						外的程序、软件、客户端等阅读、浏览X站平台内容时，因产品功能不同，特定情况下您只能阅读、浏览部分内容，如您需继续阅读、浏览剩余内容的，您需复制该页面显示的指定口令并打开X站
						App，在X站 App
						中继续您的阅读、浏览。为实现该功能，我们需要访问您的<strong>剪切板</strong>，读取其中包含的口令。
					</p>
					<p>
						在您分享或接收被分享的内容、短链等情形下，我们可能需要访问您的<strong>剪切板</strong>，读取其中包含的口令、分享码、链接，以实现自动跳转、口令跳转、分享等功能或服务。
					</p>
					<p>
						为方便您查看您已关注的用户和内容，我们将汇总您的关注记录并在「我的」主页中向您展示。同时，我们提供查看通讯录好友的功能，开启此功能需要您单独同意我们使用<strong>手机通讯录权限</strong>，以便您同意后即可看到您的通讯录好友是否为X站用户，但同时这也意味着他人也可从其通讯录中发现您的X站帐号。
					</p>
					<p>
						此外，当您回答问题时，如选择将百度网盘中的文件上传，经过您的单独授权，我们还会读写您在百度网盘中的数据。当您发布带有位置信息的内容，我们将在征得您的单独同意后，开启设备定位权限后获取设备的<strong>位置信息</strong>。当您需要上传图片时，我们将在征得您的单独同意后，获取您的<strong>相册权限或相机权限</strong>。
					</p>
					<p>
						当您使用X站的视频创作工具录制和发布配音内容时，X站为您提供「声音复刻」服务。如您需使用该服务的，需授权并开启
						<strong>麦克风权限</strong
						>。在获得您的单独同意后，我们会收集和分析您本人录制并上传的极少量音频，并生成专属于您且仅由您个人使用的虚拟音色。您可直接使用该虚拟音色为您发布的内容自动添加配音。
					</p>
					<p>
						为确保您可以实现互动、交流、信息分享，我们会通过您提供的手机号码邀请您与我们（包括我们同一集团下的关联公司）签约、合作、发布内容、以各种形式参与创作或者进行知识产权和其他权利的分享、授权和被授权活动；邀请您参与有关我们服务的调查、客户调研、售后回访；向您介绍和解释X站的产品和服务等信息。如您不希望我们和您联系，您可以按照本指引第四节所述方式拒绝或退订我们或运营方发送的前述信息。
					</p>
					<h4>账号公开信息</h4>
					<h5>个人主页</h5>
					<p>
						为展示您的个人形象和向您推荐内容，您<strong
						>可以选填并编辑您的基础信息，包括性别、生日、住址、个人简介、个人职业、工作经历、教育经历。您也可以选择进行认证，具体请查看下文关于「身份认证」的功能描述。</strong
						>
					</p>
					<p>
						<strong
						>此外，为丰富您的基础资料，您还可以设置帐号昵称，您的昵称可以和其他用户重名，X站会设置并记录专属于此帐号的系统识别标记，以便系统和其他用户能够准确分辨。您可以选择是否设置头像，但不设置头像不影响您使用。您设置头像时，可选择使用您已绑定的第三方帐号的头像，或者采取拍照上传头像或使用您设备中的照片作为头像。若您选择拍照上传头像的，我们将申请获取您的相机权限；若您选择使用您设备中的照片作为头像的，我们将申请获取您的照片/相册权限。</strong
						>
					</p>
					<p>
						生日祝福：X站始终重视对用户的人文关怀并期待通过各种方式给与用户仪式感等惊喜。如您在个人主页填写了您的<strong>生日信息</strong>，我们可能会根据该信息在您填写的日期当天以页面弹窗等形式向您发送生日祝福和生日专享福利等，您可以选择关闭或领取该福利。
					</p>
					<h5>发布、互动等公开的帐号动态</h5>
					<p>
						您的关注数和关注列表、关注您的数量和列表、您的获赞数、获得的喜欢数、获得的收藏数、获得的专业认可数、您公开发布的内容（含提问、回答、视频、想法、文章、专栏、视频合集、Live
						讲座等）、您的赞同内容、您的关注内容（含关注的专栏、话题、问题、收藏夹等）、您的收藏内容、您商品橱窗中的商品（如有）、及您帐号的其他动态（如参与盐选专栏、借阅电子书等），<strong>将会在您X站帐号的个人主页中公开展示</strong>。
					</p>
					<p>
						如其他用户关注了您或您关注了其他用户，当被关注帐号产生新的动态时，关注人将可在特定页面或特定位置（如「动态」频道等）查看到该动态详情。
					</p>
					<p>
						如您不希望某些用户关注您或与您进行其他互动，您可选择将该用户加入黑名单。请您知悉，被您加入黑名单的用户仅不能和您互动，但仍可以查看您的公开信息。
					</p>
					<h4>身份认证（个人认证）</h4>
					<p>
						X站提供认证个人身份信息的服务，目前包括学历认证、职业认证、公众人物认证、站外创作者认证。当您申请X站为您进行身份认证时，<strong
						>经过您单独同意</strong
						>
						，您需要向我们提供姓名
						<strong>、身份证号</strong> 或其他证件号、有关身份证明的信息。具体为：
					</p>
					<ul>
						<li>
							<strong
							>如您选择进行学历认证，您还需要填写您的学历、学位、教育经历（包括学校全称、专业，并上传认证材料）。</strong
							>
						</li>
						<li>
							<strong
							>如您选择进行职业认证，您还需要填写您的行业、职业、工作单位、职位、工作经历，并上传工作证明材料（包括纸质名片/工牌/在职证明）。</strong
							>
						</li>
						<li>
							<strong
							>如您选择公众人物认证，您还需要填写社会身份、曾获奖项、曾获荣誉、您在其他平台的身份证明材料。</strong
							>
						</li>
						<li>
							<strong
							>如您选择进行其他网站创作者认证，您需要授权我们从第三方平台（包括微信、哔哩哔哩、抖音、快手）共享获得您在该第三方平台的帐号链接或
								ID。</strong
							>
						</li>
					</ul>
					<p>
						<strong
						>如果您申请开通与身份认证相关的服务，请仔细阅读并确认X站针对该服务所发布的<a
							href="https://zhuanlan.zhihu.com/p/96956163"
						>《X站个人认证常见问题汇总》</a
							>。</strong
						>
					</p>
					<h4>个性化展示/推荐</h4>
					<p>
						在您使用X站 App
						时，为帮助我们更加了解您如何接入和使用我们的产品与/或服务、维护我们的产品与/或服务、维持X站
						App
						最基本的业务运转或对您作出其他方面的回应，我们可能会收集和使用您使用我们的产品与/或服务时的
						IP 地址、软件使用记录、设备信息（硬件序列号、设备 MAC 地址、IMEI、Android
						ID）。请您理解，只有在您同意我们收集上述信息后您才能使用相应X站基本的业务功能。
					</p>
					<p>
						为实现向您展现或推荐相关程度更高（而非普遍推送）的内容或者广告，我们会收集您的浏览使用记录、设备信息（设备型号、MAC
						地址、操作系统、网络环境、设备定位信息、设备的网络运营商、设备 ID、IMEI）、IP
						地址、OAID、日志信息、位置信息（我们在您开启设备位置权限时会收集设备的<strong>精确定位信息）</strong>。请注意，前述单独的各类信息是无法识别特定自然人身份的信息。如果我们将这类信息与其他信息结合使用后能够识别出特定自然人身份的，则在结合使用期间，这类信息将被视为个人信息，除取得您授权或法律法规另有规定外，我们会将这类信息做匿名化、去标识化处理。
					</p>
					<h4>网上购物和支付功能</h4>
					<p>
						当您在使用X站产品和/或服务的过程中发生充值或支付消费（含X站币充值或支付），我们会收集您的<strong>交易和消费记录（包括交易内容、交易状态、支付方式、交易时间、金额、交易单号）、流水记录</strong>，以便核对和供您查阅你的充值和消费情况。
					</p>
					<p>
						如果您开通了指纹或人脸识别支付，在您支付时，您需要使用指纹或人脸信息进行付款验证。请您知悉，指纹或人脸识别支付的功能由第三方提供，X站不会收集和存储您的该类信息。
					</p>
					<p>
						当您需要绑定银行卡将X站钱包内的余额提现时，您还需提供您的<strong>姓名、银行卡号、身份证号</strong>、银行预留的手机号码和验证码，以保证您帐户的资金安全和履行国家反洗钱的相关法规要求。
					</p>
					<p>
						为了确保您的交易安全，您可以修改您的手机号码、设置/修改<strong>支付密码</strong>，此时您需要提供您已绑定的手机号码、我们发送给您的验证码和新的<strong>支付密码</strong>，以便我们为您修改上述信息。
					</p>
					<p>
						当您在X站站内购买X站自营或第三方平台产品时，您需要向我们提供收件人
						<strong>姓名、手机号码、</strong> 收货地址，以便为您寄送产品。
					</p>
					<p>
						如您购买或领取了公开课程并进入课程学习，经您的单独授权，我们将调取您的日历权限并收集您的日程信息，以便提醒您课程情况。我们还会收集您的学习记录，以便核实您的学习情况，方便您继续学习。
					</p>
					<h4>客户服务</h4>
					<p>
						当您向X站提起投诉、申诉或进行咨询时，为了方便与您联系或帮助您解决问题，我们可能需要您提供姓名、手机号码和/或电子邮箱及其他联系方式，并可能使用这些信息与您取得联系。<strong>我们也可能会使用您在注册时提供的手机号码与您联系。<strong>如果您提交的是侵权投诉，X站还会依据法律规定要求您提交</strong>身份证</strong>、授权委托、权属证明，以明确您作为投诉主体的资格，并判断您的投诉是否成立。如根据法律规定需要将您的前述信息提交给法院或其他监管机构或者司法部门的，我们将依法提供。您不提供上述信息，我们的客服将无法为您提供前述服务，但不影响您使用我们提供的其他服务。
					</p>
					<p>
						当您作为被投诉方或纠纷相关方时，为了核实您在X站站内发布的内容，并厘清该内容是否影响和损害X站或他人权益，我们也可能会使用您在注册时提供的手机号码与您联系。
					</p>
					<h4>搜索功能</h4>
					<p>
						当您使用X站提供的搜索功能时，我们会收集和存储您查询的关键字和您在搜索结果中的点击情况。<strong
						>该等关键词信息通常无法单独识别您的个人身份，不属于您的个人信息，不在本指引的规范范围内。只有当您搜索过的关键词信息与您的其他信息有联结并可识别您的个人身份时，则在结合使用期间，我们会将您的搜索关键词信息作为您的个人信息，按照本指引对其进行处理与保护。</strong
						>
					</p>
					<h4>直播功能</h4>
					<p>
						如果您申请开通直播功能，经您单独同意后，我们需要您提交姓名、<strong>身份证号码进行实名认证</strong>，还需要您通过<strong>人脸</strong>识别，以判定您符合从事直播业务的资格，请您知悉，我们不会收集和存储您的面部识别特征信息。
					</p>
					<p>
						当您作为主播进行直播时，我们会依照法律法规规定收集、存储您的直播内容，包括您的肖像和您在直播过程中披露的其他身份信息。鉴于直播功能的特殊性，一旦您开通直播功能，您在直播过程中的直播内容将被公开，请您谨慎公开您的个人信息。
					</p>
					<p>
						当您作为观众与主播语音连麦互动时，我们会识别您的声纹，但我们不会存储该类信息。请您注意并理解，只有您成为主播后，视频连麦功能才能被开启。
					</p>
					<p>
						当您给主播赠送礼物或者您作为主播收到其他用户赠送礼物时，为进行正常结算，我们会收集您购买和<strong>消费虚拟货币（直播盐粒）的交易记录（包括交易内容、交易状态、支付方式、金额、交易时间、交易单号）</strong>。
					</p>
					<h4>故障上报</h4>
					<p>
						当发生系统故障或其他影响您正常使用本平台的问题时，您可以通过「摇一摇」或联系「X站小管家」的方式，向X站告知系统故障的情况。我们将收集您的设备型号、IP
						地址、运营商名称、网络类型、软件版本、日志信息、故障描述，以及您上传的图片、页面截图或其他材料，以用于分析和处理系统问题。
					</p>
					<h4>问卷测评</h4>
					<p>
						为了了解用户需求点，提升用户体验，我们会邀请您参与问卷调查，以便我们能够向您提供更好的服务质量，我们可能会根据实际情况收集调查问卷中您反馈内容中所含的个人信息。因每次调查问卷需要您回复的内容不同，因此，我们会在向您发送调查问卷前再次征得您的授权同意。
					</p>
					<p>
						为了提升用户体验，我们可能还会发起产品测评，如您主动参加测评的，我们将收集您的收件人
						<strong>姓名、手机号码、</strong>
						收货地址，以便为您寄送参与测评的产品。我们会在向您发起产品测评前再次征得您的授权同意。
					</p>
					<h4>保障服务稳定性与安全</h4>
					<p>
						为了保障服务的稳定性与安全性，我们将收集您的硬件型号、操作系统版本号、设备名称、设备配置、国际移动设备识别码、唯一设备标识符、网络设备硬件地址、IP
						地址、WLAN
						接入点、蓝牙、基站、软件版本号、网络接入方式、类型、状态、网络质量数据、操作、使用、服务日志。我们可能会将您的设备信息或电话号码与您的X站帐号相关联，以用于身份验证、安全防范、诈骗监测、预防或禁止非法活动、降低风险、存档和备份用途。
					</p>
					<h3 id="">
						X站 App 所调用的系统权限<a className="smart-anchor" id="X站-App-所调用的系统权限"></a>
					</h3>
					<p>
						为了向您提供X站产品和/或服务，我们可能需要使用您设备中的系统权限来收集相关个人信息。本部分将对我们在第
						1 节第 1.1
						条中涉及的所有系统权限进行归纳整理，以方便向您更加系统、完整、透明地呈现。您可以选择是否授权我们使用您设备的相关权限，即使授权后也允许您自行关闭或者再开启。关于权限的具体信息请您详见<a
							href="https://www.zhihu.com/term/permission"
						>《X站 App 权限列表》</a
						>。
					</p>
					<h3 id="">
						除同意外的其他合法性事由<a className="smart-anchor" id="除同意外的其他合法性事由"></a>
					</h3>
					<p>
						根据相关法律法规的规定，在以下情形中，我们可以在不征得您的授权同意的情况下收集、使用一些必要的个人信息：
					</p>
					<p>（1）为订立、履行个人作为一方当事人的合同所必需；</p>
					<p>（2）为履行法定职责或者法定义务所必需；</p>
					<p>
						（3）为应对突发公共卫生事件，或者紧急情况下为保护自然人的生命健康和财产安全所必需；
					</p>
					<p>
						（4）依照《中华人民共和国个人信息保护法》的规定在合理的范围内处理个人自行公开或者其他已经合法公开的个人信息；
					</p>
					<p>（5）法律、行政法规规定的其他情形。</p>
					<h2 id="">
						我们如何委托处理、共享、转让、公开披露您的个人信息<a
							className="smart-anchor"
							id="我们如何委托处理、共享、转让、公开披露您的个人信息"
						></a>
					</h2>
					<h3 id="">
						委托处理您的个人信息<a className="smart-anchor" id="委托处理您的个人信息"></a>
					</h3>
					<p>
						为了向您提供更完善、优质的产品和／或服务，某些功能可能由我们的服务合作方提供（如我们的第三方服务供应商、承包商、代理等），我们会委托服务合作方代表我们处理您的某些个人信息，例如第三方供应商代表我们发出电子邮件或推送通知、代表我们发送调研邀请、代表我们向您邮寄您已购买或确认接收的商品、对去标识化的信息进行数据统计分析。
					</p>
					<p>
						对接受我们委托处理您个人信息的公司、组织和个人，我们会与其签署严格的保密协定或数据处理协议，明确委托事项、和委托处理目的、期限、处理方式、处理个人信息的种类、保护措施以及双方的权利义务等，要求他们仅按照我们的要求、本指引以及相关的保密和安全措施来处理个人信息。如该等第三方要改变个人信息的处理目的，该等第三方应再次征求您的同意。如果您拒绝我们的服务合作方在提供服务时收集或使用为提供服务所必需的个人信息，将可能导致您无法使用部分X站产品和／或服务中由该合作方提供的服务。
					</p>
					<p>
						关于我们的合作方（委托处理）收集个人信息类型及收集目的，详情请参阅<a
							href="https://www.zhihu.com/term/sdk"
						>《与第三方共享个人信息清单》</a
						>。
					</p>
					<h3 id="">共享您的个人信息<a className="smart-anchor" id="共享您的个人信息"></a></h3>
					<p>
						为了向您提供完善的产品和服务，我们的某些服务或技术将由授权合作伙伴提供。请您知悉，我们不会主动向其他个人信息处理者提供您的个人信息，我们仅会出于合法、正当、必要、特定、明确的目的共享您的个人信息，并且只会共享必要的个人信息。在以下情形下，我们将向其他个人信息处理者提供您的个人信息，向您告知接收方的名称或者姓名、联系方式、处理目的、处理方式和个人信息的种类，并取得您的<strong
						>单独同意。</strong
						>
						同时，我们会与合作方签署严格的保密协定，要求他们严格按照我们的说明、本指引以及其他任何相关的保密政策并采取安全措施来处理您的个人信息。我们要求我们的合作方无权将共享的个人信息用于任何其他用途。<strong
						>当您查看第三方创建的网页或使用第三方开发的应用程序时，这些第三方可能会放置他们自己的
							Cookie
							或使用其他技术手段，这些技术手段不受我们的控制，且它们的使用不受本政策的约束。合作方可能有其独立的个人信息保护政策和用户协议，我们建议您阅读并遵守第三方的个人信息保护政策及用户协议。</strong
						>
					</p>
					<p>
						关于我们的合作方（共享）收集个人信息类型及收集目的，详情请参阅<a
							href="https://www.zhihu.com/term/sdk"
						>《与第三方共享个人信息清单》</a
						>。
					</p>
					<h3 id="">转让您的个人信息<a className="smart-anchor" id="转让您的个人信息"></a></h3>
					<p>
						<strong
						>原则上我们不会将您的个人信息控制权向其他公司、组织或个人进行转移。</strong
						>
						如果发生合并、收购或破产清算，将涉及到个人信息转让，此种情况下我们将向您告知接收方的名称或者姓名和联系方式，并要求新的持有您个人信息的公司、组织继续受本指引的约束。如果本指引中约定的个人信息的收集、处理方式发生任何改变，该公司、组织将重新向您征求授权同意。
					</p>
					<h3 id="">
						公开披露您的个人信息<a className="smart-anchor" id="公开披露您的个人信息"></a>
					</h3>
					<p><strong>除非获取您的单独同意，我们不会公开披露您的个人信息。</strong></p>
					<p>
						<strong
						>特别提示：使用X站的过程中，您主动公开分享、共享的个人信息，不受本指引限制（如向其他互联网平台转发内容）。您应注意，任何您分享的信息均可被任何第三方阅读、收集和使用，请您审慎考虑通过X站发布和传播的内容中含有您的个人信息。您充分了解，当您自行作出披露时，X站仅是存储了包含该等信息的内容或系统日志，但不会主动识别该等信息属于您的个人信息。只要您不删除您公开发布的信息，该信息可能会一直留存在公众领域；在一些情况下，即使您删除您公开发布的信息，该等信息仍可由其他用户或与X站没有关联及不受X站控制的第三方独立地缓存、复制或储存，或通过其他用户或第三方在公众领域保存。例如，当您将您在X站发表的回答转发到其他互联网平台，该平台将独立地展示、缓存或保存您转发的内容，其他互联网用户也转发、保存您的回答，而相应的页面将不受X站的控制。</strong
						>
					</p>
					<h2 id="">
						我们如何保护您的个人信息<a className="smart-anchor" id="我们如何保护您的个人信息"></a>
					</h2>
					<p>
						您的个人信息安全对于我们至关重要。我们将严格遵守相关法律法规，采取业内认可的合理可行的措施，保护您的个人信息。防止信息遭到未经授权的访问、披露、使用、修改，避免信息损坏或丢失。
					</p>
					<h3 id="">
						技术措施与数据安全措施<a className="smart-anchor" id="技术措施与数据安全措施"></a>
					</h3>
					<p>
						我们努力采取各种符合业界标准的物理、电子和管理方面的安全措施来保护您的个人信息安全。我们积极建立数据分类分级制度、数据安全管理规范、数据安全开发规范来管理规范个人信息的存储和使用，确保未收集与我们提供的服务无关的个人信息。
					</p>
					<p>
						我们通过与信息接触者签署保密协议、监控和审计机制来对数据进行全面安全控制。防止您的个人信息遭到未经授权的访问、公开披露、使用、修改、损坏或丢失。
					</p>
					<p>
						我们已使用符合业界标准的安全防护措施保护您提供的个人信息，防止数据遭到未经授权的访问、公开披露、使用、修改，防止数据发生损坏或丢失。我们会采取一切合理可行的措施，保护您的个人信息。例如，在您的浏览器与X站之间交换数据（如信用卡信息）时受
						SSL 加密保护；我们同时对本指引「引言」中出现的网站提供 https
						安全浏览方式；我们会使用加密技术确保数据的保密性；我们会使用受信赖的保护机制防止数据遭到恶意攻击；我们会部署访问控制机制，确保只有授权人员才可以访问个人信息；以及我们会举办安全和隐私保护培训课程，加强员工对于保护个人信息重要性的认识。当我们展示您的个人信息时，我们会采用包括内容替换、匿名处理等方式对您的信息进行脱敏展示，以保护您的信息安全。
					</p>
					<h3 id="">安全认证<a className="smart-anchor" id="安全认证"></a></h3>
					<p>
						我们已通过了公安部信息安全等级保护三级认证，并与监管机构、第三方测评机构建立了良好的协调沟通机制，及时抵御并处置各类信息安全威胁，为您的信息安全提供全方位保障。
					</p>
					<h3 id="">安全事件处置<a className="smart-anchor" id="安全事件处置"></a></h3>
					<p>
						我们将尽力确保您发送给我们的任何信息的安全性，但请您理解，由于技术的限制以及在互联网行业存在的各种恶意手段，我们无法保证信息百分之百的安全。您需要了解，您接入我们服务所用的系统和通讯网络，有可能因我们可控范围外的因素而出现问题。为防止安全事故的发生，我们制定了妥善的预警机制和应急预案。若不幸发生个人信息安全事件，我们将按照法律法规的要求，及时向您告知：安全事件的基本情况和影响、我们已采取或将要采取的处置措施、您可自主防范和降低风险的建议和对您的补救措施，并立即启动应急预案，力求将损失最小化。我们将及时就事件相关情况以电话、推送通知等方式告知您，难以逐一告知用户时，我们会采取合理、有效的方式发布公告。
					</p>
					<p>
						同时，我们还将按照监管部门要求，主动上报个人信息安全事件的处置情况，紧密配合政府机关的工作。
					</p>
					<h2 id="">
						您如何管理您的个人信息<a className="smart-anchor" id="您如何管理您的个人信息"></a>
					</h2>
					<p>
						<strong
						>我们非常重视实现您对个人信息的管理，并提供了多种功能以保障您对于个人信息访问、更正、删除以及撤回同意等权利。用户在使用X站微信小程序时，如果想要管理创作、赞同、喜欢、收藏板块的相关信息，请在X站
							App 内进行操作，具体操作详见下列路径描述。</strong
						>
					</p>
					<h3 id="">
						管理帐号、发布的内容与相关记录<a
							className="smart-anchor"
							id="管理帐号、发布的内容与相关记录"
						></a>
					</h3>
					<h4>查询、更正与补充帐号信息</h4>
					<p>
						【设置 →
						帐号与安全】您可通过这一功能查看和修改帐号密码，修改绑定手机号、绑定邮箱、绑定社交帐号；可以访问您的X站帐号的最近活动历史，了解您的帐号在一个月内的登录设备、地点。您可以设置信任设备，以减少与登录有关的安全验证。
					</p>
					<p>
						【我的 →
						个人主页】您可以在「编辑资料」中查看和修改您的其他帐号信息，包括头像、用户名、一句话介绍、性别、生日、居住地、所在行业、职业经历、教育经历、个人简介；您可以自行或邀请好友给您添加形象关键词，也可以编辑或删除形象关键词。您可以管理标识展示。
					</p>
					<h4>管理创作有关记录</h4>
					<p>
						【我的 → 创作 →
						内容管理】您可以查看、修改、删除您已发布的内容的数据情况，包括已发布的回答、文章、直播、提问、想法、专栏、视频，以及您保存的草稿。但您删除已发布的内容，仅是取消其公开展示，<strong>X站仍需要依据法律法规的要求，对您曾经发布的内容（除草稿箱内容外）进行后台的存储保留</strong>。您也可以在该路径下查看您已发布内容的数据情况。
					</p>
					<p>
						【我的 → 创作 →
						内容分析】您可以查看您已发布内容（包括回答、视频、文章）的数据情况和数据趋势。主要数据包括阅读总量、播放总量、互动数量（获得的赞同、评论、喜欢、收藏）。
					</p>
					<p>
						【我的 → 创作 →
						收益分析】您可以查看您当前帐号下在X站平台获得的收益情况和收益趋势。主要数据包括今日收益、累计收益、创作余额、分日列表、内容收益等。
					</p>
					<h4>管理浏览、关注和收藏记录</h4>
					<p>
						【我的 →
						最近浏览】您可以查询/关闭最近浏览记录，批量删除或全部清空您的浏览记录。若您使用X站微信小程序的过程中想要删除其中的最近浏览信息，您可以通过发送电子邮件到18307106535@163.com的方式，向我们提出删除个人信息的请求。
					</p>
					<p>
						【我的 →
						关注】您可以管理所有关注列表，包括您关注的用户、专栏、问题、话题、专题、圆桌、收藏夹。
					</p>
					<p>【我的 → 收藏】您可以管理您收藏的单个话题或您建立的收藏夹、您追更的内容。</p>
					<h4>管理购买/使用记录</h4>
					<p>
						【我的 →
						钱包】您可以查看在本平台内您的账户余额、X站币、直播盐粒和直播盐币的余额、交易记录、您拥有的礼券。
					</p>
					<p>【我的 → 已购】您可以查看在本平台内的消费订单详情。</p>
					<p>
						【我的 →
						书架】您可以查看在X站内阅读、浏览过的书籍和课程详情（含付费和免费内容），并可做下载、筛选、删除和管理。
					</p>
					<h4>管理个人认证</h4>
					<p>
						【我的 →
						个人主页】您可以在编辑资料中申请/取消个人认证，或查看和修改X站个人认证信息。
					</p>
					<h4>清除缓存信息</h4>
					<p>【我的 → 设置 → 清除缓存】您可以通过该路径清除X站在您设备中的缓存。</p>
					<h3 id="">删除您的个人信息<a className="smart-anchor" id="删除您的个人信息"></a></h3>
					<p>
						除 4.1 条所述的您管理和删除个人信息的方式和情形外，
						在以下情形中，我们将主动删除您的个人信息。如我们未删除的，您可通过发送邮件至18307106535@163.com向我们提出删除个人信息的请求：
					</p>
					<p>（1）处理目的已实现、无法实现或者为实现处理目的不再必要；</p>
					<p>（2） 我们停止提供产品或者服务，或者保存期限已届满；</p>
					<p>（3）您撤回同意；</p>
					<p>（4）我们违反法律、行政法规或者违反约定处理个人信息；</p>
					<p>（5）法律、行政法规规定的其他情形。</p>
					<p>
						<strong
						>您删除信息后，我们将据此调整X站向您提供的产品和/或服务。但请您理解，这不会影响此前基于您的授权而开展的个人信息处理。</strong
						>
					</p>
					<h3 id="">获取您的个人信息<a className="smart-anchor" id="获取您的个人信息"></a></h3>
					<p>
						如您需要查阅X站已收集的您的个人信息，您可在【我的 → 设置 →
						已收集个人信息清单】中查看。
					</p>
					<p>
						如您需要获取您的个人信息副本，您可在【我的 → 设置 → 隐私中心 →
						个人信息下载】页面联系「X站小管家」后申请下载X站已收集的您的个人信息。
					</p>
					<h3 id="">撤回您的授权同意<a className="smart-anchor" id="撤回您的授权同意"></a></h3>
					<p><strong>1. 撤回对消息和推送的同意</strong></p>
					<p>
						【我的 →
						设置】您可以选择和管理消息设置、推送通知设置。您也可以针对推送通知设置免打扰模式。
					</p>
					<p><strong>2. 撤回对个性化推荐的同意</strong></p>
					<p>
						【我的 → 设置 → 隐私中心 →
						权限授权设置】您可以在该页面撤回对个性化内容推荐和个性化广告推荐的同意，具体包括：
					</p>
					<p>
						（1）关闭个性化内容推荐：您可以选择是否接受X站依据算法向您推荐可能感兴趣的内容。关闭后将会取消向您推荐您可能感兴趣的问答、文章、课程、书籍等内容，X站仅向您随机推送内容，您看到的内容的推荐相关度会降低。
					</p>
					<p>
						（2）关闭个性化广告推荐：您可以选择是否接受个性化广告推荐。关闭后将会降低广告与您的相关度，但您看到的广告数量不会减少。
					</p>
					<p><strong>3. 撤回其他授权</strong></p>
					<p>您可以在【我的 → 设置 → 隐私中心 → 权限授权设置】页面进行：</p>
					<p>
						（1）权限设置：您可以在「权限设置」版块管理、设置、撤回您在使用X站时已开启的系统权限。
					</p>
					<p>
						（2）撤回个人信息保护指引：您可以通过点击「撤回隐私协议」的方式选择撤回对本指引的授权。当您撤回后，需要您重新对您的授权状态做出选择，以便您可以继续使用X站的产品或服务。
					</p>
					<p>
						（3）撤回「营销短信和电话」：您选择撤回后，X站将不再基于推介、营销、邀约合作目的，使用您注册时提供的手机号码与您联系和/或向您发送基于上述目的的短信通知。
					</p>
					<p>
						请您知悉：当您撤回同意或授权后，我们将不再收集和处理相应的个人信息，但请您理解，当您撤回同意或授权后，我们无法继续为您提供该同意或授权所对应的特定功能和/或服务。您撤回同意或授权的决定，不会影响此前基于您的同意或授权而开展的个人信息处理活动的效力。
					</p>
					<h3 id="">注销X站帐号<a className="smart-anchor" id="注销X站帐号"></a></h3>
					<p>
						如果您需要注销您的X站帐号，您需在【我的 → 专属客服/反馈与帮助 →
						帐号注销】页面中提交申请，并依据页面指示填写信息，以便我们核实您的请求。在注销帐号之后，我们将停止为您提供X站的全部产品和/或服务，并依据法律法规相关要求通过匿名化等方式处理您的个人信息，或删除与您帐户相关的个人信息，但法律法规或监管机构对用户信息存储时间另有规定的除外。<strong
						>有关注销帐号的相关规则和流程，请参见<a
							href="https://www.zhihu.com/term/deactive"
						>《用户注销重要提醒》</a
							>。</strong
						>
					</p>
					<h3 id="">
						限制处理您的个人信息<a className="smart-anchor" id="限制处理您的个人信息"></a>
					</h3>
					<p>
						请您知悉并理解，为了您能正常使用X站产品和/或服务，您需要向我们提供与该产品和/或服务相关的必要个人信息。在产品设置中，您可以对与个人信息相关的授权和功能进行调整。如果您希望更加具体和个性化地限制我们对您个人信息的处理或者不想接受我们发送给您的商业广告或营销信息，您可以发送电子邮件到【<a
							href="mailto:privacy@zhihu.xn--com-003b"
						>18307106535@163.com】</a
						>。
					</p>
					<h3 id="">响应您的上述请求<a className="smart-anchor" id="响应您的上述请求"></a></h3>
					<p>
						<strong
						>为保障您的帐号安全，我们会首先对您的身份进行验证（如要求您提供书面请求或其他方式），</strong
						>
						然后再处理您的请求。<strong>我们将于收到您请求后的十五个工作日内完成对您身份的核验和对您请求的响应</strong>。
					</p>
					<p>
						对于您合理的请求，我们原则上不收取费用。<strong
						>但对多次重复、超出合理限度的请求，我们将视情况收取一定的成本费用。对于那些与法律法规要求相悖、无端重复、需要过多技术手段（比如需要开发新系统或者从根本上改变现行惯例）、给他人合法权益带来风险或者非常不切实际的请求，我们可能会予以拒绝。</strong
						>
					</p>
					<p>
						如您对自身作为数据主体权利有进一步要求或存在任何疑问、意见或建议，可通过本指引中「如何联系我们」一节所述方式与我们取得联系并行使您的相关权利。
					</p>
					<h2 id="">
						我们如何存储您的个人信息<a className="smart-anchor" id="我们如何存储您的个人信息"></a>
					</h2>
					<p>
						<strong
						>我们将对从中华人民共和国境内获得的用户个人信息存放于中华人民共和国境内，并在本指引所述目的所需的最短期限内保留您的个人信息。超出保存期限后，我们会对您的个人信息进行删除或者匿名化处理，但国家法律法规、规章、规范性文件或政府的政策、命令等另有要求或为履行我们的合规义务而需要保留您的个人信息的除外。例如：《中华人民共和国电子商务法》要求商品和服务信息、交易信息保存时间自交易完成之日起不少于三年；《中华人民共和国网络安全法》要求采取监测、记录网络运行状态、网络安全事件的技术措施，并按照规定留存相关的网络日志不少于六个月。</strong
						>
					</p>
					<h2 id="">
						我们如何使用 Cookie 和其他技术<a
							className="smart-anchor"
							id="我们如何使用-Cookie-和其他技术"
						></a>
					</h2>
					<p>
						您使用我们的服务时，我们会在您的计算机或移动设备上存储名为 Cookie
						的小数据文件。Cookie
						通常包含标识符、站点名称以及一些号码和字符。我们使用该等信息判断注册用户是否已经登录，提升服务和/或产品质量及优化用户体验。如您不希望个人信息保存在
						Cookie 中，您可对浏览器进行配置，选择禁用 Cookie 功能。
					</p>
					<p>
						您可根据自己的偏好管理或删除 Cookie。您可以清除计算机上保存的所有
						Cookie，大部分网络浏览器都设有阻止 Cookie 的功能。
					</p>
					<p>以下链接提供了有关如何在所有主流浏览器中控制 Cookie 的说明：</p>
					<p>Google Chrome：https://support.google.com/chrome/answer/95647?hl=en;</p>
					<p>IE：https://support.microsoft.com/en-us/help/260971/description-of-cookies;</p>
					<p>Safari（桌面版）：https://support.apple.com/kb/PH5042?locale=en_US;</p>
					<p>Safari（移动版）：https://support.apple.com/en-us/HT201265;</p>
					<p>
						火狐浏览器：https://support.mozilla.org/en-US/kb/cookies-information-websites-store-on-your-computer?redirectlocale=en-US&amp;redirectslug=Cookies;
					</p>
					<p>Opera：https://www.opera.com/zh-cn/help。</p>
					<p>如您使用其他浏览器，请参阅浏览器制造商提供的文档。</p>
					<p>
						请您知悉，倘若您拒绝使用或清除已有的追踪技术，则需要在每一次访问时亲自更改用户设置，并且，我们可能无法向您提供更加优质的使用体验，部分服务亦可能会无法正常运作。
					</p>
					<h2 id="">
						我们如何处理未成年人的个人信息<a
							className="smart-anchor"
							id="我们如何处理未成年人的个人信息"
						></a>
					</h2>
					<p>
						我们的产品、网站和服务主要面向成年人。若您是 18
						周岁以下的未成年人，请您不要或终止使用我们的产品和/或服务。
					</p>
					<p>
						若您是未成年人的监护人，当您对您所监护的未成年人是否使用我们的服务或其向我们是否提供信息有任何疑问时，请您及时按照第九条所述方式与我们联系。如果我们发现自己在不知情的情况下收集了未成年人的个人信息，会设法尽快删除相关数据。
					</p>
					<h2 id="">
						我们如何更新与修改本指引<a className="smart-anchor" id="我们如何更新与修改本指引"></a>
					</h2>
					<p>
						<strong
						>虽然本指引说明了我们在保护个人信息方面所遵循的标准，但这些标准可能会随我们适时的修订而发生变化，该等修订构成本指引的一部分。本指引为《X站协议（草案）》的重要组成部分。X站保留不时更新或修改本指引的权利。当本指引发生变更时，我们会通过本平台客户端以推送通知、弹窗、系统通知、站内私信等合理方式通知您，以便您能及时了解本指引所做的任何变更。您可在本平台中通过【我的
							→ 设置 → 隐私中心 → 个人信息保护指引】查看本指引的最新内容。</strong
						>
					</p>
					<p>
						<strong
						>请您注意，只有在获取您的同意后，我们才会按照更新后的声明收集、使用、处理和存储您的个人信息。未经您明确同意，我们不会削减您按照本指引所应享有的权利。</strong
						>
					</p>
					<p>
						对于重大变更，视具体情况我们<strong>还会提供更为显著的通知</strong>说明本指引的具体变更内容。<strong
						>重大变更包括但不限于：</strong
						>
					</p>
					<p>
						（1）我们的服务模式发生重大变化。如处理个人信息的目的、处理的个人信息类型、个人信息的使用方式等；
					</p>
					<p>
						（2）我们在所有权结构、组织架构等方面发生重大变化。如业务调整、破产并购等引起的所有者变更等；
					</p>
					<p>（3）个人信息共享、转让或公开披露的主要对象发生变化；</p>
					<p>（4）您参与个人信息处理方面的权利及其行使方式发生重大变化；</p>
					<p>（5）我们负责处理个人信息安全的责任部门、联络方式及投诉渠道发生变化；</p>
					<p>（6）个人信息安全影响评估报告表明存在高风险时。</p>
					<p>若您不同意修改后的个人信息保护指引，您有权并应立即停止使用X站的服务。</p>
					<h2 id="">您如何联系我们<a className="smart-anchor" id="您如何联系我们"></a></h2>
					<p>
						当您对本指引有任何疑问，可以通过X站官方帐号「X站小管家」联系我们，或发送邮件至
						&nbsp;<a href="mailto:18307106535@163.com">18307106535@163.com</a>&nbsp;
						咨询，我们设立了个人信息保护专职部门，将及时解决您的问题。<strong
						>我们将在收到您的请求后十五个工作日内完成对您身份和请求的响应和处理，协助解决您的问题。</strong
						>
					</p>
					<p>
						<strong
						>请您理解并知悉，为保障安全和高效处理您的问题并及时向您反馈，我们会在验证您的身份后处理您的请求。当我们验证您的身份时，可能会要求您提供相关证据。</strong
						>
					</p>
					<h2 id="">争议解决<a className="smart-anchor" id="争议解决"></a></h2>
					<p>
						<strong
						>因本指引以及我们处理您个人信息事宜引起的任何争议，您可诉至北京市海淀区人民法院。如果您认为我们的个人信息处理行为损害了您的合法权益，您也可向有关政府部门进行反映。</strong
						>
					</p>
					<h2 id="">概念及定义<a className="smart-anchor" id="概念及定义"></a></h2>
					<p>本指引中使用到的名词，在通常意义中有如下定义：</p>
					<p>
						（1）个人信息：以电子或者其他方式记录的与已识别或者可识别的自然人有关的各种信息，包括但不限于自然人的姓名、出生日期、<strong
						>身份证件号码、个人生物识别信息、</strong
						>
						住址、电话号码等，不包括匿名化处理后的信息。
					</p>
					<p>
						（2）敏感个人信息：一旦泄露或者非法使用，容易导致自然人的人格尊严受到侵害或者人身、财产安全受到危害的个人信息，包括<strong>生物识别、宗教信仰、特定身份、医疗健康、金融账户、行踪轨迹</strong>等信息，以及不满十四周岁未成年人的个人信息，例如，敏感个人信息包括<strong
						>身份证件号码、个人生物识别信息、银行帐号、通信内容、健康生理信息</strong
						>
						等。
					</p>
					<p>
						（3）日志信息：包括您在使用X站时发布、浏览的内容，您发布内容时的操作时间、类型、网络原地址、目标地址、端口，访问的日期和时间，登录
						IP 信息。
					</p>
					<p>（4）关注列表：包括您关注的用户、内容列表（包括话题、收藏夹等）。</p>
					<p>
						（5）通讯录信息：您所存储的联系人信息，包括手机号、名称。为收集上述信息，我们可能需要申请您授权我们使用设备的电话权限和存储权限。
					</p>
					<p>
						<strong
						>（6）精准定位信息：指 GPS
							或基站信息。为收集上述信息，我们需要申请您授权我们使用设备的位置权限。</strong
						>
					</p>
					<p>（7）交易记录：指购买商品或服务的交易时间、购买产品、支付价格。</p>
					<p>
						（8）去标识化：个人信息经过处理，使其在不借助额外信息的情况下无法识别特定自然人的过程。
					</p>
					<p>（9）匿名化：个人信息经过处理无法识别特定自然人且不能复原的过程。</p>
					<p>
						（10）中国大陆或中国大陆境内：指中华人民共和国大陆地区，仅为本指引之目的，不包含香港特别行政区、澳门特别行政区和台湾地区。
					</p>
				</div>
			</div>
		</>
	)
}
export default Privacy